var map = {
	"./APPR.svg": "f9c2",
	"./CAN.svg": "7be2",
	"./CLOSED.svg": "f8f8",
	"./COMP.svg": "ce75",
	"./DISPTCHD.svg": "f4a8",
	"./FLDCOMP.svg": "ee6c",
	"./INPRG.svg": "e5fa",
	"./PENDING.svg": "5b27",
	"./WAPPR.svg": "07dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13db";